import '~/css/shared/loader.css';

import $ from 'jquery';

import httpClient from '@/bundles/http-client';

$(function() {
    const $uploadMenu = $('#upload_menu');

    if ($uploadMenu.length > 0) {
        $uploadMenu.closest('li.dropdown').on('show.bs.dropdown', function () {
            if (!$uploadMenu.data('content-loaded')) {
                httpClient.get('/api/v1/3d-models/dropdown').then((response) => {
                    $uploadMenu.html($(response.data).html());
                    $uploadMenu.data('content-loaded', true);
                });
            }
        });
    }
});
